import { Component, computed, inject, output, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent, ModalComponent } from '@webapp/ui';
import { IUser } from '@webapp/users/interfaces/users.interface';
import { QuoterStoreService } from '../../../store/quoter-store.service';
import { SearchUsersComponent } from '../search-users/search-users.component';

@Component({
  selector: 'app-producer-selector-modal',
  standalone: true,
  imports: [ModalComponent, ButtonComponent, SearchUsersComponent],
  templateUrl: './producer-selector-modal.component.html',
})
export class ProducerSelectorModalComponent {
  private readonly store = inject(QuoterStoreService);
  private readonly router = inject(Router);

  userSelected = output<IUser>();

  readonly selectedUser = signal<IUser | null>(null);
  readonly isVisible = computed(() => !this.store.state().agent?.id);

  setUser(user: IUser): void {
    this.selectedUser.set(user);
  }

  selectUser(): void {
    const user = this.selectedUser() ?? ({} as IUser);
    this.store.set('agent', user);
    this.userSelected.emit(user);
    this.selectedUser.set(null);
  }

  cancel(): void {
    this.router.navigateByUrl('cotizaciones');
  }
}
